import styled from 'styled-components';
import posed from 'react-pose';
import _IconArrowRight from '../Icons/IconArrowRight';

export const Fader = styled.label`
  display: block;
  position: absolute;
  top: 30px;
  left: 0;
  width: 100%;
  height: calc(100% - 30px);
  background-color: #fff;
  opacity: 1;
  transition: opacity 0.4s linear, width 0.4s linear;

  @media (min-width: 1000px) {
    top: 40px;
    height: calc(100% - 40px);
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 20px 79px 19px 15px;
  font-size: 21px;
  border: none;
  box-shadow: 0 5px 20px 0 rgba(0, 1, 44, 0.15);
  outline: none;
  font-family: 'Futura';

  &::placeholder {
    color: #000;
  }

  @media (min-width: 1000px) {
    padding: 28px 100px 28px 20px;
    font-size: 30px;
  }
`;

export const InputAnimate = posed.div({
  preEnter: {
    opacity: 0
  },
  enter: {
    opacity: 1,
    transition: { duration: 400 }
  },
  exit: {
    opacity: 0,
    transition: { duration: 400 }
  }
});

export const Inner = styled.div`
  position: relative;
  display: block;
  padding-top: 30px;

  @media (min-width: 1000px) {
    padding-top: 40px;
  }

  &.is-active,
  ${Input}:focus {
    &:before {
      opacity: 0;
      width: 0;
    }
  }

  &.is-active label,
  ${Input}:focus ~ label {
    top: -20px;
    left: -15px;
    font-size: 18px;

    @media (min-width: 1000px) {
      top: -30px;
      left: -20px;
      font-size: 24px;
    }
  }

  &.is-active ${Fader}, ${Input}:focus ~ ${Fader} {
    top: 30px;
    left: 0;
    opacity: 0;
    width: 0;

    @media (min-width: 1000px) {
      top: 40px;
    }
  }
`;

export const Label = styled.label`
  overflow: hidden;
  position: absolute;
  top: 30px;
  left: 0;
  margin-left: 15px;
  margin-top: 20px;
  font-size: 21px;
  transition: all 0.2s cubic-bezier(0, 0.25, 0.5, 1);
  user-select: none;

  @media (min-width: 1000px) {
    top: 40px;
    margin-left: 20px;
    margin-top: 30px;
    font-size: 30px;
  }
`;

export const LabelInner = posed.div({
  preEnter: {
    opacity: 0,
    y: 30
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: { duration: 400 }
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: { duration: 400 }
  }
});

export const Button = styled.button`
  position: absolute;
  top: 50%;
  right: 0;
  width: 64px;
  height: 64px;
  margin-top: -17px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffed00;
  transition: background-color 0.2s, color 0.2s;
  border: none;
  cursor: pointer;
  outline: none;

  svg path {
    transition: fill 0.2s, color 0.2s;
  }

  &:hover {
    background: #000;
    svg path {
      fill: #ffed00;
    }
  }

  &:disabled {
    background-color: #e0e1e2;
    cursor: default;
  }

  @media (min-width: 1000px) {
    right: 16px;
    margin-top: -12px;
  }
`;

export const IconArrowRight = styled(_IconArrowRight)`
  font-size: 20px;
`;
